import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BasicInformation from "../../../components/customer/individual-customer/BasicInformation";
import BusinessInformation from "../../../components/customer/individual-customer/BusinessInformation";
import ContactInformation from "../../../components/customer/individual-customer/ContactInformation";
import Identification from "../../../components/customer/individual-customer/Identification";
import NextOfKin from "../../../components/customer/individual-customer/NextOfKin";
import PageTitle from "../../../components/partials/PageTitle";
import { setActiveTab } from "../../../redux/slice/customer/customerSlice";

const IndividualCustomerApplication = ({
  customerInfo,
  updateCustomerRecordHandler,
  customerType,
}) => {
  const { application_info } = useSelector((state) => state.customer);
  const [activeTab, setActive] = useState(application_info?.current_tab);
  const dispatch = useDispatch();
  let basicInfoRef = useRef("");
  let bizInfoRef = useRef("");
  let contactInfoRef = useRef("");
  let idInfoRef = useRef("");
  let nokInfoRef = useRef("");

  const setActiveTabHandler = (tab) => {
    setActive(tab);
  };

  // breadcrumb
  const breadcrumb = {
    from: {
      title: "Add Customer",
      link: "/admin/add-customer",
    },
    current: {
      title: "individual",
      link: null,
    },
  };

  useEffect(() => {
    dispatch(setActiveTab(activeTab));
  }, [activeTab]);

  return (
    <>
      {/* page title */}
      <PageTitle
        title='Individual Customer Application'
        breadcrumb={breadcrumb}
      />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body p-2'>
              <div className='content border p-2 rounded-2'>
                <h5 className='text-dark text-uppercase'>Basic Information</h5>
                <div className='form-wrapper px-3'>
                  <div className='row'>
                    <ul className='nav nav-tabs mb-'>
                      <li className='nav-item'>
                        <a
                          href='#home'
                          data-bs-toggle='tab'
                          aria-expanded='true'
                          className='nav-link active'
                          ref={basicInfoRef}
                        >
                          <i className='mdi mdi-home-variant d-md-none d-block'></i>
                          <span className='d-none d-md-block'>
                            Basic Information
                          </span>
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          href='#profile'
                          data-bs-toggle='tab'
                          aria-expanded='false'
                          className='nav-link'
                          ref={bizInfoRef}
                        >
                          <i className='mdi mdi-account-circle d-md-none d-block'></i>
                          <span className='d-none d-md-block'>
                            Business Information
                          </span>
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          href='#settings'
                          data-bs-toggle='tab'
                          aria-expanded='false'
                          className='nav-link'
                          ref={contactInfoRef}
                        >
                          <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                          <span className='d-none d-md-block'>
                            Contact Information
                          </span>
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          href='#identification'
                          data-bs-toggle='tab'
                          aria-expanded='false'
                          className='nav-link'
                          ref={idInfoRef}
                        >
                          <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                          <span className='d-none d-md-block'>
                            Identification
                          </span>
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          href='#nok'
                          data-bs-toggle='tab'
                          aria-expanded='false'
                          className='nav-link'
                          ref={nokInfoRef}
                        >
                          <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                          <span className='d-none d-md-block'>Next Of Kin</span>
                        </a>
                      </li>
                    </ul>

                    <div className='tab-content px-0'>
                      <div className='tab-pane active' id='home'>
                        <BasicInformation bizInfoRef={bizInfoRef} />
                      </div>
                      <div className='tab-pane' id='profile'>
                        <BusinessInformation contactInfoRef={contactInfoRef} />
                      </div>
                      <div className='tab-pane' id='settings'>
                        <ContactInformation idInfoRef={idInfoRef} />
                      </div>
                      <div className='tab-pane' id='identification'>
                        <Identification
                          customerInfo={customerInfo}
                          nokInfoRef={nokInfoRef}
                        />
                      </div>
                      <div className='tab-pane' id='nok'>
                        <NextOfKin customerType={customerType} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndividualCustomerApplication;
